module.exports = __webpack_public_path__ + "img/scraps.0ddd9156.webp";